import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import BuildIcon from '@mui/icons-material/Build';

const RoleSelectionDialog = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleRoleSelect = (role) => {
    navigate(`/signup?role=${role}`);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Typography variant="h5" fontWeight="bold" color="primary">
          Welcome to Autoshops.com!
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ mb: 3, color: 'text.secondary' }}
        >
          Are you a car owner or auto shop owner?
        </Typography>

        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
            justifyContent: 'center'
          }}
        >
          {/* Car Owner Button */}
          <Button
            variant="contained"
            size="large"
            onClick={() => handleRoleSelect('User')}
            startIcon={<PersonIcon />}
            sx={{
              flex: 1,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              backgroundColor: '#e63926',
              '&:hover': {
                backgroundColor: '#d32f2f'
              }
            }}
          >
            Car Owner
          </Button>

          {/* Auto Shop Owner Button */}
          <Button
            variant="contained"
            size="large"
            onClick={() => handleRoleSelect('Mechanic')}
            startIcon={<BuildIcon />}
            sx={{
              flex: 1,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0'
              }
            }}
          >
            Auto Shop Owner
          </Button>
        </Box>

        <Typography 
          variant="body2" 
          align="center" 
          sx={{ mt: 3, color: 'text.secondary' }}
        >
          Select your role to get started with the right signup form
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default RoleSelectionDialog;

